/**
 * Labstep
 */

import type { ValueGetterParams } from 'ag-grid-community';
import { ICONS } from 'labstep-web/constants/icons';
import type { CellRendererParams } from 'labstep-web/core/DataGrid/types';
import type { Resource } from 'labstep-web/models/resource.model';

export const colDefResourceTemplate = {
  colId: 'template',
  headerName: 'Category',
  headerComponentParams: {
    icon: ICONS.resource_template.primary,
  },
  editable: false,
  cellRenderer: (params: CellRendererParams<Resource>) => {
    return params.node?.data?.template
      ? params.node?.data?.template.name || 'Untitled Category'
      : 'No Category';
  },
  valueGetter: (params: ValueGetterParams) =>
    params.node?.data?.template?.idAttr || null,
  valueGetterExport: (params: ValueGetterParams) =>
    params.node?.data?.template
      ? params.node?.data?.template.name || 'Untitled Category'
      : 'No Category',
};
